export class OperationalStatus {
  constructor(
    public code?: number,
    public label?: string,
    public order?: number
  ) { }

  clone() {
    return new OperationalStatus(
      this.code,
      this.label,
      this.order
    );
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/operational-status.ts